import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { EstimateStatusesEnum } from '../../estimate-data/estimate-data.data';
import {
  DocumentEmailStatesEnum,
  DocumentOverallStatesEnum,
} from '../document-data.data';

export const STATES_SCHEMA = Object.freeze({
  EMAIL: '',
  OVERALL: DocumentOverallStatesEnum.unsent,
  DUE_DATE: null, // i2g-timezoneless-date (yyyy-mm-dd)
  DATE_PAID: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  DATE_PRINTED: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  DATE_SENT: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  ESTIMATE_STATUS: null, // EstimateStatusesEnum
  ESTIMATE_DONE_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
});
const RECORD = generateSchema(STATES_SCHEMA);
const KEYS: any = generateKeys(STATES_SCHEMA);

export class States extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get datePaid(): string {
    return this.get(KEYS.DATE_PAID);
  }

  get datePrinted(): string {
    return this.get(KEYS.DATE_PRINTED);
  }

  get dateSent(): string {
    return this.get(KEYS.DATE_SENT);
  }

  get overall(): DocumentOverallStatesEnum {
    return this.get(KEYS.OVERALL);
  }

  get dueDate(): string {
    return this.get(KEYS.DUE_DATE);
  }

  get email(): DocumentEmailStatesEnum {
    return this.get(KEYS.EMAIL);
  }

  get estimateStatus(): EstimateStatusesEnum {
    return this.get(KEYS.ESTIMATE_STATUS);
  }

  get estimateDateDone(): string {
    return this.get(KEYS.ESTIMATE_DONE_DATE);
  }
}
